import { render } from "./SurveySettingModal.vue?vue&type=template&id=21e5ea49"
import script from "./SurveySettingModal.vue?vue&type=script&lang=js"
export * from "./SurveySettingModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__